import React, { useState, useEffect } from "react";
import { Box, Container, Typography } from "@mui/material";
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { postData } from '../../Webservice/Webservice';
import { useNavigate } from "react-router-dom";

function Footer() {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const tokenValue = sessionStorage.getItem("token");
        const token = tokenValue ? `Bearer ${tokenValue}` : "";
        const response = await postData('category/list', {}, token, false);

        if (response && response.categories && Array.isArray(response.categories)) {
          const activeCategories = response.categories.filter(cat => cat.status === 'active');
          setCategories(activeCategories);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  const handleCategoryClick = (category) => {
    const categorySlug = category.title?.toLowerCase().replace(/\s+/g, '-') || 'category';
    navigate(`/${categorySlug}`, {
      state: { categoryId: category._id, categoryTitle: category.title }
    });
  };

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#1a1a1a",
        color: "white",
        pt: 8,
        pb: 3,
      }}
    >
      <Container>
        {/* Main Footer Content */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(4, 1fr)",
            },
            gap: 6,
            mb: 6,
          }}
        >
          {/* About Column */}
          <Box>
            <Box
              component="img"
              src="/img/tvfmlogo1.png"
              alt="TVFM Logo"
              sx={{ height: 55, width: "auto", mb: 3 }}
            />
            <Typography
              sx={{
                fontSize: "14px",
                lineHeight: 1.8,
                color: "rgba(255,255,255,0.7)",
                mb: 3,
              }}
            >
              Premium grooming products and professional barber services for the modern gentleman.
            </Typography>
            {/* Social Icons */}
            <Box sx={{ display: "flex", gap: 2 }}>
              {[
                { Icon: FacebookIcon, label: "Facebook" },
                { Icon: InstagramIcon, label: "Instagram" },
                { Icon: TwitterIcon, label: "Twitter" },
                { Icon: YouTubeIcon, label: "YouTube" },
              ].map(({ Icon, label }) => (
                <Box
                  key={label}
                  component="a"
                  href={`https://${label.toLowerCase()}.com/yourprofile`}
                  target="_blank"
                  rel="noopener"
                  sx={{
                    width: 40,
                    height: 40,
                    border: "1px solid rgba(255,255,255,0.2)",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    color: "white",
                    "&:hover": {
                      bgcolor: "white",
                      color: "#222",
                      borderColor: "white",
                    },
                  }}
                >
                  <Icon sx={{ fontSize: 20 }} />
                </Box>
              ))}
            </Box>
          </Box>

          {/* Categories Column */}
          <Box>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 600,
                mb: 3,
                letterSpacing: "1px",
              }}
            >
              CATEGORIES
            </Typography>
            {/*categories*/}
            {categories.map((category) => (
              <Typography
                key={category._id}
                onClick={() => handleCategoryClick(category)}
                sx={{
                  fontSize: "14px",
                  color: "rgba(255,255,255,0.7)",
                  mb: 2,
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    color: "white",
                    paddingLeft: "8px",
                  },
                }}
              >
                {category.title}
              </Typography>
            ))}
          </Box>

          {/* Contact Column */}
          <Box>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 600,
                mb: 3,
                letterSpacing: "1px",
              }}
            >
              CONTACT US
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                color: "rgba(255,255,255,0.7)",
                mb: 2,
                lineHeight: 1.8,
              }}
            >
              No-2/S1, VGN Platina,<br />
              Thiruverkadu Road,Ayapakkam, Chennai – 600077<br />
              India
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                color: "rgba(255,255,255,0.7)",
                mb: 1,
              }}
            >
              Phone: +91 9940658115
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                color: "rgba(255,255,255,0.7)",
              }}
            >
              Email: tvfmsynergy@gmail.com
            </Typography>
          </Box>
        </Box>

        {/* Divider */}
        <Box
          sx={{
            height: "1px",
            bgcolor: "rgba(255,255,255,0.1)",
            mb: 4,
          }}
        />

        {/* Bottom Footer */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            sx={{
              fontSize: "13px",
              color: "rgba(255,255,255,0.5)",
            }}
          >
            © 2025 Glam Company - Designed By Digital Triumph Private Limited💛.
          </Typography>
          <Box sx={{ display: "flex", gap: 4 }}>
            {["Terms & Conditions", "Privacy Policy"].map((item) => (
              <Typography
                key={item}
                sx={{
                  fontSize: "13px",
                  color: "rgba(255,255,255,0.5)",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  // ...rubikfont,
                  "&:hover": {
                    color: "white",
                  },
                }}
                onClick={() => {
                  if (item === "Terms & Conditions") {
                    navigate("/terms-and-conditions");
                  } else if (item === "Privacy Policy") {
                    navigate("/privacy-policy");
                  }
                }}
              >
                {item}
              </Typography>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;


